import Cabine from "../assets/plans/cabine.svg";
import TractorLeft from "../assets/plans/tractorLeft.svg";
import TractorRight from "../assets/plans/tractorRight.svg";
import TractorFront from "../assets/plans/tractorFront.svg";
import TractorBack from "../assets/plans/tractorBack.svg";
import CarrierLeft from "../assets/plans/carrierLeft.svg";
import CarrierRight from "../assets/plans/carrierRight.svg";
import TrailerBack from "../assets/plans/trailerBack.svg";
import TrailerFront from "../assets/plans/trailerFront.svg";
import TrailerLeft from "../assets/plans/trailerLeft.svg";
import TrailerRight from "../assets/plans/trailerRight.svg";
import CabineResp from "../assets/svgresponsive/cabine.svg";
import TractorLeftResp from "../assets/svgresponsive/tractorLeft.svg";
import TractorRightResp from "../assets/svgresponsive/tractorRight.svg";
import TractorFrontResp from "../assets/svgresponsive/tractorFront.svg";
import TractorBackResp from "../assets/svgresponsive/tractorBack.svg";
import CarrierLeftResp from "../assets/svgresponsive/carrierLeft.svg";
import CarrierRightResp from "../assets/svgresponsive/carrierRight.svg";
import TrailerBackResp from "../assets/svgresponsive/trailerBack.svg";
import TrailerFrontResp from "../assets/svgresponsive/trailerFront.svg";
import TrailerLeftResp from "../assets/svgresponsive/trailerLeft.svg";
import TrailerRightResp from "../assets/svgresponsive/trailerRight.svg";
import Document from "../assets/plans/document.svg";
import TrailerInside from "../assets/plans/trailerInside.svg";
import CarrierTrailerInside from "../assets/plans/carrierTrailerInside.svg";

export const inspectionRouteMapping = (
  vehicleId?: string
): {
  [key: string]: {
    [key: string]: {
      name: string;
      description: string;
      svg: string;
      svgres: string;
      prevUrl: string;
      nextUrl: string;
      breadcrumbState: number;
      type: string;
      side: string;
      securityCheck?: boolean;
    };
  };
} => {
  return {
    Tractor: {
      Document: {
        name: "Document",
        description: "Avant chaque départ,",
        svg: Document,
        svgres: Document,
        prevUrl: "/",
        nextUrl: `/inspection/${vehicleId}/Tractor/Inside`,
        breadcrumbState: 1.1,
        type: "Tractor",
        side: "Document",
      },
      Inside: {
        name: "Cabine",
        description: "Inspectez la cabine du tracteur et",
        svg: Cabine,
        svgres: CabineResp,
        prevUrl: `/inspection/${vehicleId}/Tractor/Document`,
        nextUrl: `/inspection/${vehicleId}/Tractor/Left`,
        breadcrumbState: 1.2,
        type: "Tractor",
        side: "Inside",
        securityCheck: true,
      },
      Left: {
        name: "Côté gauche",
        description: "Inspectez le côté du tracteur et",
        svg: TractorLeft,
        svgres: TractorLeftResp,
        prevUrl: `/inspection/${vehicleId}/Tractor/Inside`,
        nextUrl: `/inspection/${vehicleId}/Tractor/Front`,
        breadcrumbState: 1.3,
        type: "Tractor",
        side: "Left",
      },
      Front: {
        name: "Face",
        description: "Inspectez la face avant du tracteur et",
        svg: TractorFront,
        svgres: TractorFrontResp,
        prevUrl: `/inspection/${vehicleId}/Tractor/Left`,
        nextUrl: `/inspection/${vehicleId}/Tractor/Right`,
        breadcrumbState: 1.4,
        type: "Tractor",
        side: "Front",
      },
      Right: {
        name: "Côté droit",
        description: "Inspectez le côté du tracteur et",
        svg: TractorRight,
        svgres: TractorRightResp,
        prevUrl: `/inspection/${vehicleId}/Tractor/Front`,
        nextUrl: `/inspection/${vehicleId}/Tractor/Back`,
        breadcrumbState: 1.5,
        type: "Tractor",
        side: "Right",
      },
      Back: {
        name: "Arrière",
        description: "Inspectez l'arrière du tracteur et",
        svg: TractorBack,
        svgres: TractorBackResp,
        prevUrl: `/inspection/${vehicleId}/Tractor/Right`,
        nextUrl: `/identification/${vehicleId}/trailer`,
        breadcrumbState: 1.6,
        type: "Tractor",
        side: "Back",
      },
    },
    Carrier: {
      Document: {
        name: "Document",
        description: "Avant chaque départ,",
        svg: Document,
        svgres: Document,
        prevUrl: "/",
        nextUrl: `/inspection/${vehicleId}/Carrier/Inside`,
        breadcrumbState: 1.1,
        type: "Carrier",
        side: "Document",
      },
      Inside: {
        name: "Cabine",
        description: "Inspectez la cabine du porteur et",
        svg: Cabine,
        svgres: CabineResp,
        prevUrl: `/inspection/${vehicleId}/Carrier/Document`,
        nextUrl: `/inspection/${vehicleId}/Carrier/Left`,
        breadcrumbState: 1.2,
        type: "Carrier",
        side: "Inside",
        securityCheck: true,
      },
      Left: {
        name: "Côté gauche",
        description: "Inspectez le côté du porteur et",
        svg: CarrierLeft,
        svgres: CarrierLeftResp,
        prevUrl: `/inspection/${vehicleId}/Carrier/Inside`,
        nextUrl: `/inspection/${vehicleId}/Carrier/Front`,
        breadcrumbState: 1.3,
        type: "Carrier",
        side: "Left",
      },
      Front: {
        name: "Face",
        description: "Inspectez la face avant du porteur et",
        svg: TractorFront,
        svgres: TractorFrontResp,
        prevUrl: `/inspection/${vehicleId}/Carrier/Left`,
        nextUrl: `/inspection/${vehicleId}/Carrier/Right`,
        breadcrumbState: 1.4,
        type: "Carrier",
        side: "Front",
      },
      Right: {
        name: "Côté droit",
        description: "Inspectez le côté du porteur et",
        svg: CarrierRight,
        svgres: CarrierRightResp,
        prevUrl: `/inspection/${vehicleId}/Carrier/Front`,
        nextUrl: `/inspection/${vehicleId}/Carrier/Back`,
        breadcrumbState: 1.5,
        type: "Carrier",
        side: "Right",
      },
      Back: {
        name: "Arrière",
        description: "Inspectez l'arrière du porteur et",
        svg: TrailerBack,
        svgres: TrailerBackResp,
        prevUrl: `/inspection/${vehicleId}/Carrier/Right`,
        nextUrl: `/inspection/${vehicleId}/Carrier/TrailerInside`,
        breadcrumbState: 1.6,
        type: "Carrier",
        side: "Back",
      },
      TrailerInside: {
        name: "Intérieur",
        description: "Inspectez l'intérieur du porteur et",
        svg: CarrierTrailerInside,
        svgres: CarrierTrailerInside,
        prevUrl: `/inspection/${vehicleId}/Carrier/Back`,
        nextUrl: `/inspection/${vehicleId}/finishjourney`,
        breadcrumbState: 1.7,
        type: "Carrier",
        side: "TrailerInside",
        securityCheck: true,
      },
    },
    Trailer: {
      Document: {
        name: "Document",
        description: "Avant chaque départ,",
        svg: Document,
        svgres: Document,
        prevUrl: `/identification/${vehicleId}/trailer`,
        nextUrl: `/inspection/${vehicleId}/Trailer/Left`,
        breadcrumbState: 3.1,
        type: "Trailer",
        side: "Document",
      },
      Left: {
        name: "Côté gauche",
        description: "Inspectez le côté de la semi-remorque et",
        svg: TrailerLeft,
        svgres: TrailerLeftResp,
        prevUrl: `/inspection/${vehicleId}/Trailer/Document`,
        nextUrl: `/inspection/${vehicleId}/Trailer/Front`,
        breadcrumbState: 3.2,
        type: "Trailer",
        side: "Left",
      },
      Front: {
        name: "Face",
        description: "Inspectez la face avant de la semi-remorque et",
        svg: TrailerFront,
        svgres: TrailerFrontResp,
        prevUrl: `/inspection/${vehicleId}/Trailer/Left`,
        nextUrl: `/inspection/${vehicleId}/Trailer/Right`,
        breadcrumbState: 3.3,
        type: "Trailer",
        side: "Front",
      },
      Right: {
        name: "Côté droit",
        description: "Inspectez le côté de la semi-remorque et",
        svg: TrailerRight,
        svgres: TrailerRightResp,
        prevUrl: `/inspection/${vehicleId}/Trailer/Front`,
        nextUrl: `/inspection/${vehicleId}/Trailer/Back`,
        breadcrumbState: 3.4,
        type: "Trailer",
        side: "Right",
      },
      Back: {
        name: "Arrière",
        description: "Inspectez l'arrière de la semi-remorque et",
        svg: TrailerBack,
        svgres: TrailerBackResp,
        prevUrl: `/inspection/${vehicleId}/Trailer/Right`,
        nextUrl: `/inspection/${vehicleId}/Trailer/TrailerInside`,
        breadcrumbState: 3.5,
        type: "Trailer",
        side: "Back",
      },
      TrailerInside: {
        name: "Intérieur",
        description: "Inspectez l'intérieur de la semi-remorque et",
        svg: TrailerInside,
        svgres: TrailerInside,
        prevUrl: `/inspection/${vehicleId}/Trailer/Back`,
        nextUrl: `/inspection/${vehicleId}/finishjourney`,
        breadcrumbState: 3.6,
        type: "Trailer",
        side: "TrailerInside",
        securityCheck: true,
      },
    },
  };
};
